import { render } from "./AccountTypeLozenge.vue?vue&type=template&id=05d313ca&scoped=true"
import script from "./AccountTypeLozenge.vue?vue&type=script&lang=js"
export * from "./AccountTypeLozenge.vue?vue&type=script&lang=js"

import "./AccountTypeLozenge.vue?vue&type=style&index=0&id=05d313ca&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05d313ca"]])

export default __exports__